import { createReportSettings, reports, widgetReport } from 'api/report';
import { actions, types } from 'reducers/dashboard/location/loyalCustomers';
import { call, put, takeLatest } from 'redux-saga/effects';

function* fetchReport({ requestDate, timezone, period, location }) {
  try {
    const response = yield call(
      widgetReport,
      reports.VEHICLE_NEW_LOYAL_WITH_SESSIONS,
      createReportSettings(requestDate, timezone, period, null, location)
    );

    yield put(actions.reportSuccess(requestDate, timezone, period, response.data));
  } catch (e) {
    yield put(actions.reportFailure(requestDate, timezone, period, e));
  }
}

export default function* loyalCustomers() {
  yield takeLatest(types.REPORT_REQUEST, fetchReport);
}
